import React, { memo } from 'react';
import { Button } from 'antd';
import {
  useSearchParamsSelector,
  useSearchParamsMethods,
} from '../../../../shared/packages/searchParamsManager';
import {
  searchParamKeys,
  searchParamSelectors,
} from '../../../../shared/configs/searchParams';
import { useEvent } from '../../../../../../hooks/useEvent';
import { useCalendarManager } from '../../../../services/queries/calendar';
import styles from './index.module.scss';

const typeToIcon = {
  increment: 'right',
  decrement: 'left',
};

const { calendarPage: pageKey, calendarMode: modeKey } = searchParamKeys;

const MemoizedAction = memo(Action);

const CalendarPagination = () => {
  const page = useSearchParamsSelector((state) => {
    return Number(state[pageKey]);
  });

  const mode = useSearchParamsSelector(searchParamSelectors[modeKey]);

  const { setParams } = useSearchParamsMethods();

  const calendarManager = useCalendarManager();

  const count = calendarManager.getPageCount(mode);

  const increment = useEvent(() => setParams({ [pageKey]: page + 1 }));
  const decrement = useEvent(() => setParams({ [pageKey]: page - 1 }));

  const decrementDisabled = page <= 1;
  const incrementDisabled = page >= count;

  return (
    <div className={styles.root}>
      <MemoizedAction
        icon={typeToIcon.decrement}
        onClick={decrement}
        disabled={decrementDisabled}
      />
      <span>
        {page} / {count}
      </span>
      <MemoizedAction
        icon={typeToIcon.increment}
        onClick={increment}
        disabled={incrementDisabled}
      />
    </div>
  );
};

export default CalendarPagination;

function Action({ icon, onClick, disabled = false }) {
  return (
    <Button
      icon={icon}
      className={styles.action}
      disabled={disabled}
      onClick={onClick}
    />
  );
}
